var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"typewriter-text"},[_vm._l((_vm.partialText),function(letter){return [_vm._v(_vm._s(letter))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }